import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "estate-param" }
const _hoisted_2 = { class: "estate-param" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_4 = { class: "estate-param date" }
const _hoisted_5 = { class: "estate-param gender" }
const _hoisted_6 = { class: "estate-param" }
const _hoisted_7 = {
  key: 1,
  class: "estate-param"
}
const _hoisted_8 = {
  key: 2,
  class: "estate-param"
}
const _hoisted_9 = {
  key: 0,
  class: "estate-param"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_11 = {
  key: 4,
  class: "estate-param"
}
const _hoisted_12 = {
  key: 5,
  class: "estate-param"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_14 = {
  key: 6,
  class: "estate-param"
}
const _hoisted_15 = {
  key: 7,
  class: "estate-param"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "m²", -1)
const _hoisted_17 = {
  key: 8,
  class: "estate-param"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_19 = {
  key: 9,
  class: "estate-param"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_21 = {
  key: 10,
  class: "estate-param"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_23 = {
  key: 11,
  class: "estate-param"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "x", -1)
const _hoisted_25 = {
  key: 12,
  class: "estate-param"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "x", -1)
const _hoisted_27 = {
  key: 13,
  class: "estate-param"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "x", -1)
const _hoisted_29 = {
  key: 14,
  class: "estate-param"
}
const _hoisted_30 = {
  key: 15,
  class: "estate-param double-size"
}
const _hoisted_31 = {
  key: 16,
  class: "estate-param"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "x", -1)
const _hoisted_33 = {
  key: 17,
  class: "estate-param"
}
const _hoisted_34 = {
  key: 18,
  class: "estate-param"
}
const _hoisted_35 = {
  key: 19,
  class: "estate-param networks double-size"
}
const _hoisted_36 = { class: "icons" }
const _hoisted_37 = ["title"]
const _hoisted_38 = ["title"]
const _hoisted_39 = ["title"]
const _hoisted_40 = ["title"]
const _hoisted_41 = {
  key: 20,
  class: "estate-param"
}
const _hoisted_42 = {
  key: 21,
  class: "estate-param"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SexIcon = _resolveComponent("SexIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isRoommate)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, [
                _createTextVNode(_toDisplayString(_ctx.ad.personCount), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.personCount')) + " /", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.ad.bedCount), 1)
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.bedCount')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, [
                _createTextVNode(_toDisplayString(_ctx.ad.estateArea), 1),
                _hoisted_3
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.isHouse ? 'AdParams.estateArea-house' : 'AdParams.estateArea')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, [
                (_ctx.ad.availableFrom)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.date(_ctx.ad.availableFrom, 'dd. MM.')) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(_ctx.ad.availableFrom, 'yyyy')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdParams.availableFrom-now')), 1)
                    ], 64))
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.availableFrom')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_SexIcon, {
                  type: _ctx.ad.adSex
                }, null, 8, ["type"]),
                _createTextVNode(_toDisplayString(_ctx.ad.adSexTitle), 1)
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.sex')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.ad.adAgeTitle), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.age')), 1)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.ad.roomCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.ad.roomCount), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.roomCount')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.floor && _ctx.ad.maxFloor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.ad.floor) + "/" + _toDisplayString(_ctx.ad.maxFloor), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.floor')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isRoommate)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          (_ctx.ad.estateArea && !_ctx.isLand)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, [
                    _createTextVNode(_toDisplayString(_ctx.ad.estateArea), 1),
                    _hoisted_10
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.isHouse ? 'AdParams.estateArea-house' : 'AdParams.estateArea')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.ad.energyPrice && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.currency(_ctx.ad.energyPrice, _ctx.ad.currency)), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.energyPrice')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.usefulArea && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.usefulArea), 1),
              _hoisted_13
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.usefulArea')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.landArea && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.landArea), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.ares')), 1)
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.landArea')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.builtUpArea && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.builtUpArea), 1),
              _hoisted_16
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.builtUpArea')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.balconyArea != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.balconyArea), 1),
              _hoisted_18
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.balconyArea')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.loggiaArea != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.loggiaArea), 1),
              _hoisted_20
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.loggiaArea')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.terraceArea != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.terraceArea), 1),
              _hoisted_22
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.terraceArea')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.liftCount && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.liftCount) + " ", 1),
              _hoisted_24
            ]),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.liftCount')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.garageCount && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.garageCount) + " ", 1),
              _hoisted_26
            ]),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.garageCount')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.cellarCount && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.cellarCount) + " ", 1),
              _hoisted_28
            ]),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.cellarCount')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.hasCellar === true && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('AdParams.yes')), 1),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.hasCellar')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.statusTitle && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.ad.statusTitle.toLowerCase()), 1),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.status')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.parkingPlaceCount && !_ctx.isDeveloperProjectEstate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.ad.parkingPlaceCount) + " ", 1),
              _hoisted_32
            ]),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.parkingPlaceCount')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.hasSmokersAllowed !== undefined && _ctx.ad.hasSmokersAllowed !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t(_ctx.ad.hasSmokersAllowed ? 'AdParams.yes' : 'AdParams.no')), 1),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.hasSmokersAllowed')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.hasPetsAllowed !== undefined && _ctx.ad.hasPetsAllowed !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t(_ctx.ad.hasPetsAllowed ? 'AdParams.yes' : 'AdParams.no')), 1),
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.hasPetsAllowed')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.ad.hasWaterNetwork === true || _ctx.ad.hasGasNetwork === true || _ctx.ad.hasCanalizationNetwork === true || _ctx.ad.hasElectricityNetwork === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_36, [
              (_ctx.ad.hasWaterNetwork === true)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    title: _ctx.$t('AdParams.hasWaterNetwork'),
                    class: "icon-water"
                  }, null, 8, _hoisted_37))
                : _createCommentVNode("", true),
              (_ctx.ad.hasGasNetwork === true)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    title: _ctx.$t('AdParams.hasGasNetwork'),
                    class: "icon-gas"
                  }, null, 8, _hoisted_38))
                : _createCommentVNode("", true),
              (_ctx.ad.hasCanalizationNetwork === true)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    title: _ctx.$t('AdParams.hasCanalizationNetwork'),
                    class: "icon-canalization"
                  }, null, 8, _hoisted_39))
                : _createCommentVNode("", true),
              (_ctx.ad.hasElectricityNetwork === true)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 3,
                    title: _ctx.$t('AdParams.hasElectricityNetwork'),
                    class: "icon-electricity"
                  }, null, 8, _hoisted_40))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.networks')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDeveloperProject)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.ad.adCount), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.adCount')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDeveloperProject && _ctx.ad.maxFloor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.ad.maxFloor), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdParams.maxFloor')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}